import api from './api';

const webhookFlowService = {
  list:          (workspaceId, botId) => api.get(`/workspaces/${workspaceId}/webhook-flows?botId=${botId}`),
  create:        (workspaceId, botId, name) => api.post(`/workspaces/${workspaceId}/webhook-flows`, { botId, name }),
  get:           (workspaceId, id) => api.get(`/workspaces/${workspaceId}/webhook-flows/${id}`),
  update:        (workspaceId, id, data) => api.put(`/workspaces/${workspaceId}/webhook-flows/${id}`, data),
  remove:        (workspaceId, id) => api.delete(`/workspaces/${workspaceId}/webhook-flows/${id}`),
  regenerateKey: (workspaceId, id) => api.post(`/workspaces/${workspaceId}/webhook-flows/${id}/regenerate-key`),
};

export default webhookFlowService;
